/* Eliá SPA: seleção de unidade no pop-up. */

if (!window.Eurus.loadedScript.has("locales-form.js")) {
  window.Eurus.loadedScript.add("locales-form.js");

  window.EurusSetLocalizationCookie = function (rawValue) {
    const expires = new Date(Date.now() + 12096e5).toUTCString();

    document.cookie =
      `localizationForm=${encodeURIComponent(rawValue)}; ` +
      `expires=${expires}; path=/; ` +
      `domain=.eliaspa.com.br; SameSite=Lax`;
  };

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xLocalizationForm", () => ({
        openCountry: false,
        loading: false,
        cachedResults: false,

        init() {
          const root = this.$el;

          // Regras aplicadas aos seletores fora do pop-up.
          if (!root.closest(".box-select-unidade")) {
            const unitNames = {
              US: "Pier 21 - DF",
              AR: "Casa Park - DF",
              PY: "Sudoeste - DF",
              UY: "Lago Norte - DF",
              CO: "Liv Mall - PB",
              EC: "Altiplano - PB",
              AM: "Parahyba Mall - PB",
              GY: "Alphaville - SP",
              SV: "Araraquara - SP",
              GT: "Jundiaí - SP",
              CL: "Palmas - TO"
            };

            const readSavedLocalization = () => {
              let raw = null;

              try {
                // O cookie compartilhado tem prioridade porque funciona
                // entre todos os subdomínios das unidades.
                const match = document.cookie.match(
                  /(?:^|; )localizationForm=([^;]*)/
                );

                raw = match
                  ? decodeURIComponent(match[1])
                  : localStorage.getItem("localizationForm");
              } catch (error) {
                raw = localStorage.getItem("localizationForm");
              }

              if (raw == null) return null;

              try {
                return JSON.parse(raw);
              } catch (error) {
                return raw;
              }
            };

            const applyHeaderFallback = () => {
              if (window.EurusPier21FallbackInProgress) return;

              /*
               * Não executa troca automática de Market dentro
               * do Editor de Temas da Shopify.
               */
              if (
                window.Shopify &&
                window.Shopify.designMode
              ) {
                return;
              }

              /*
               * Visitas de campanha têm prioridade.
               * Mantém o domínio/subdomínio definido pelo link.
               */
              if (
                typeof window.EurusIsCampaignVisit === "function" &&
                window.EurusIsCampaignVisit()
              ) {
                return;
              }

              // BR é o contexto padrão atual que exibe Parahyba Mall.
              if (
                !window.Shopify ||
                window.Shopify.country !== "BR"
              ) {
                return;
              }

              const popup = document.querySelector(
                ".box-select-unidade"
              );

              const popupIsVisible =
                popup &&
                window.getComputedStyle(popup).display !== "none" &&
                popup.getClientRects().length > 0;

              // Se o pop-up estiver aberto, o cliente deve fazer a escolha.
              if (popupIsVisible) return;

              const stored = readSavedLocalization();

              const storedIsObject =
                stored && typeof stored === "object";

              const storedCountry = storedIsObject
                ? String(stored.value || "").toUpperCase()
                : typeof stored === "string"
                  ? stored.toUpperCase()
                  : "";

              const storedIsExpired = Boolean(
                storedIsObject &&
                stored.expires &&
                Date.now() >= Number(stored.expires)
              );

              /*
               * Se houver uma unidade válida escolhida anteriormente,
               * reaplica essa escolha.
               *
               * Se não houver, utiliza Pier 21 como padrão.
               */
              const targetCountry =
                unitNames[storedCountry] && !storedIsExpired
                  ? storedCountry
                  : "US";

              const targetName = unitNames[targetCountry];

              window.EurusPier21FallbackInProgress = true;

              // Utiliza o mesmo processo atual de troca de Market,
              // inclusive a verificação e limpeza do carrinho.
              this.submit(
                targetCountry,
                "currency_selector",
                targetName
              );
            };

            window.EurusPier21FallbackRun =
              applyHeaderFallback;

            /*
             * Corrige também quando o navegador restaura a página
             * pelo cache ao utilizar os botões voltar ou avançar.
             */
            if (!window.EurusPier21FallbackPageShowBound) {
              window.EurusPier21FallbackPageShowBound = true;

              window.addEventListener(
                "pageshow",
                (event) => {
                  if (!event.persisted) return;

                  window.EurusPier21FallbackInProgress =
                    false;

                  window.setTimeout(() => {
                    if (
                      typeof window.EurusPier21FallbackRun ===
                      "function"
                    ) {
                      window.EurusPier21FallbackRun();
                    }
                  }, 100);
                }
              );
            }

            this.$nextTick(() => {
              window.setTimeout(
                applyHeaderFallback,
                500
              );
            });

            return;
          }

          const form = root.closest("form");

          const label = root.querySelector(
            ".toolbar-button .label-container > span"
          );

          const countryInput =
            form &&
            form.querySelector(
              'input[name="country_code"]'
            );

          const mainContent =
            document.getElementById("MainContent");

          const previousVisibility = mainContent
            ? mainContent.style.visibility
            : "";

          const resetPrompt = () => {
            if (label) {
              label.textContent =
                "Selecione uma unidade";
            }

            if (countryInput) {
              countryInput.value = "";
            }

            this.openCountry = false;
          };

          const syncPopup = (isOpen) => {
            if (isOpen) {
              resetPrompt();
            }

            // Oculta a vitrine enquanto o pop-up aguarda a escolha.
            // A Shopify ainda renderiza a página no contexto atual.
            if (mainContent) {
              mainContent.style.visibility = isOpen
                ? "hidden"
                : previousVisibility;
            }
          };

          this._eliaRestoreContent = () => {
            if (mainContent) {
              mainContent.style.visibility =
                previousVisibility;
            }
          };

          resetPrompt();

          // "show" pertence ao componente xPopups que envolve o seletor.
          this.$watch("show", (isOpen) => {
            this.$nextTick(() => {
              syncPopup(Boolean(isOpen));
            });
          });

          this.$nextTick(() => {
            syncPopup(Boolean(this.show));
          });
        },

        destroy() {
          if (
            typeof this._eliaRestoreContent ===
            "function"
          ) {
            this._eliaRestoreContent();
          }
        },

        async submit(value, input, name) {
          const fn_submit = () => {
            const form = this.$el.closest(
              "#localization_form"
            );

            form.querySelector("#" + input).value =
              value;

            form.submit();
          };

          const storedRaw = localStorage.getItem(
            "localizationForm"
          );

          const stored = xParseJSON(storedRaw);

          const storedValue =
            stored && typeof stored === "object"
              ? stored.value
              : stored;

          if (value !== storedValue) {
            const cart = await this.getCart();

            if (cart && cart?.items?.length > 0) {
              await this.cleanCart(
                value,
                name,
                fn_submit
              );

              return;
            }
          }

          const payload = JSON.stringify({
            value,
            name,
            expires:
              Date.now() + 336 * 60 * 60 * 1000
          });

          localStorage.setItem(
            "localizationForm",
            payload
          );

          window.EurusSetLocalizationCookie(payload);

          fn_submit();
        },

        async getCart() {
          try {
            const response = await fetch(
              window.Shopify.routes.root + "cart.js"
            );

            if (!response.ok) {
              throw new Error(
                `Erro ao buscar carrinho: ${response.status}`
              );
            }

            return await response.json();
          } catch (error) {
            console.error("getCart error:", error);
            return null;
          }
        },

        async cleanCart(
          cacheValue,
          cacheName,
          cb
        ) {
          Swal.fire({
            title: "Atenção!",
            html: `
              Não é possível adicionar ao carrinho, produtos de unidades diferentes.<br>
              Ao mudar de unidade o seu carrinho será limpo e você precisará selecionar novos produtos.
            `,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText:
              "Mudar para Unidade Selecionada",
            cancelButtonText:
              "Continuar na Unidade Atual",
            reverseButtons: true,
            customClass: {
              confirmButton:
                "button button-action",
              cancelButton:
                "button button-outline"
            }
          }).then(async (result) => {
            if (result.isConfirmed) {
              if (cacheValue) {
                const payload = JSON.stringify({
                  value: cacheValue,
                  name: cacheName,
                  expires: Date.now() + 12096e5
                });

                localStorage.setItem(
                  "localizationForm",
                  payload
                );

                window.EurusSetLocalizationCookie(
                  payload
                );
              }

              await fetch(
                window.Shopify.routes.root +
                  "cart/clear.js"
              ).catch((error) => {
                console.error(
                  "Failed in cleaning the cart: ",
                  error
                );
              });

              cb();
            }
          });
        },

        loadCountry(el) {
          if (this.cachedResults) {
            this.openCountry = true;
            return true;
          }

          const optionEL = el
            .closest(".country-selector")
            .querySelector(".country-options");

          this.loading = true;

          fetch(
            window.Shopify.routes.root +
              "?section_id=country-selector"
          )
            .then((response) => response.text())
            .then((response) => {
              const content = new DOMParser()
                .parseFromString(
                  response,
                  "text/html"
                )
                .getElementById("list-country")
                .innerHTML;

              optionEL.innerHTML = content;
              this.cachedResults = true;
              this.openCountry = true;
            })
            .finally(() => {
              this.loading = false;
            });
        }
      }));
    });
  });
}